
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.875 20.25a.796.796 0 01-.13-.011 1.126 1.126 0 01-.983-.983.796.796 0 010-.261c.06-.513.47-.923.983-.983a.699.699 0 01.261-.001c.513.06.923.47.983.983a.817.817 0 010 .262c-.06.513-.47.923-.983.983a.817.817 0 01-.131.011z"}}),_c('path',{attrs:{"d":"M19.875 23.25c-2.274 0-4.125-1.851-4.125-4.125S17.601 15 19.875 15c.976 0 1.894.337 2.625.947V11.25a.75.75 0 00-.75-.75H9.813l-.38 1.07a5.994 5.994 0 014.019 4.93h.798a.75.75 0 010 1.5h-.798c-.372 2.971-2.921 5.25-5.952 5.25S1.921 20.971 1.548 18H.75a.75.75 0 010-1.5h.798a6.014 6.014 0 016.4-5.232l3.204-9.019A2.253 2.253 0 0113.273.75H19.5A2.252 2.252 0 0121.75 3v6A2.252 2.252 0 0124 11.25v7.875a4.13 4.13 0 01-4.125 4.125zm0-6.75c-1.448 0-2.625 1.177-2.625 2.625s1.177 2.625 2.625 2.625 2.625-1.177 2.625-2.625-1.177-2.625-2.625-2.625zM3.067 18c.361 2.133 2.234 3.75 4.433 3.75s4.072-1.617 4.433-3.75H3.067zm8.866-1.5c-.361-2.133-2.234-3.75-4.433-3.75s-4.072 1.617-4.433 3.75h8.866zM20.25 9V3a.75.75 0 00-.75-.75h-3V9h3.75zM15 9V2.25h-1.727a.752.752 0 00-.707.5L10.346 9H15z"}})])
          )
        }
      }
    